import * as React from 'react'

import { cn } from '@/lib/utils'

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean
  description?: string
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, description, ...props }, ref) => {
    const textareaClasses = cn(
      'border-input bg-background placeholder:text-muted-foreground focus-visible:ring-primary/40 hover:border-foreground/20 flex min-h-[80px] w-full rounded-md border px-3 py-2 text-sm shadow-sm transition-[box-shadow,border-color] duration-150 focus-visible:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-50',
      error && 'border-destructive focus-visible:ring-destructive',
      className
    )

    return (
      <div className="w-full">
        <textarea
          className={textareaClasses}
          ref={ref}
          {...props}
          aria-invalid={error ? 'true' : undefined}
          aria-describedby={description ? `${props.id || ''}-description` : undefined}
        />
        {description && (
          <p
            id={`${props.id || ''}-description`}
            className={cn('text-muted-foreground mt-1 text-xs', error && 'text-destructive')}
          >
            {description}
          </p>
        )}
      </div>
    )
  }
)
Textarea.displayName = 'Textarea'

export { Textarea }
